<div class="list-item">
  <div class="row align-items-center row-mobile-container no-gutters">
    <div class="col-9 col-md-5 col-lg-6 description-container">
      <p id="materialNumber" class="mpup-inventory-text">{{item.materialNumber}}</p>
      <p id="productDescription" class="mpup-inventory-text bold">{{item.materialDescription}}</p>
    </div>


    <div class="col-8 col-md-3 col-lg-3 tray-amount-container">
      <div class="d-flex justify-content-start justify-content-md-end align-items-center">
        <p
          [class.not-shown]="item.tray === ''"
          class="mpup-inventory-text max-amount-text"
        >
          {{'mpupInventory.tray' | mbTranslate}}
        </p>
        <div class="round-info-highlight" [class.not-shown]="item.tray === ''">
          <p>{{item.tray}}</p>
        </div>
        <div class="amount-wrapper">
          <mb-mpup-amount-circle
            [amount]="item.totalQuantity"
            [maxAmount]="item.targetQuantity"
          >
          </mb-mpup-amount-circle>
        </div>
        <p
          class="mpup-inventory-text max-amount-text"
        >
          {{'mpupInventory.of' | mbTranslate}}{{ ' ' + item.targetQuantity}}
        </p>
      </div>
    </div>

    <div class="col-4 col-md-2 col-lg-1 price-container">
      <p class="mpup-inventory-text price">
        {{item.price + ' ' + item.priceUnit}}
      </p>
    </div>

    <div class="col-3 col-md-2 col-lg-2 d-flex justify-content-center expand-container">
      <button class="expand-button" (click)="toggleExpansion()">
        <img [src]="expanded ? '/assets/images/Icon_chevron_up.svg' : '/assets/images/Icon_chevron_down.svg'"
             alt="Expand"
             class="expand-icon"
        />
      </button>
    </div>

  </div>

  <div
    *ngIf="expanded"
    class="row expanded-row"
  >
    <div class="col-12 col-md-6 mobile-no-padding">
      <table>
        <thead>
        <tr>
          <th class="start">{{'mpupInventory.lotNo' | mbTranslate}}</th>
          <th>{{'mpupInventory.expirationDate' | mbTranslate}}</th>
          <th>{{'mpupInventory.amount' | mbTranslate}}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let tableRow of item.materialCollection" class="collection-row">
          <td class="start">{{tableRow.batchNumber}}</td>
          <td>{{tableRow.expiryDate | date: 'yyyy-MM-dd'}}</td>
          <td>{{tableRow.amount}}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="col-12 col-md-4 offset-md-2 col-lg-3 offset-lg-3 d-flex flex-column mobile-no-padding">
      <a
        *ngIf="(getDataSheetUrl() | async) !== null"
        target="_blank"
        [href]="getDataSheetUrl() | async"
      >
        <img
          src="assets/images/Icon_pdf.svg"
          [alt]="'mpupInventory.downloadDataSheet' | mbTranslate"
        />
        {{'mpupInventory.downloadDataSheet' | mbTranslate}}
      </a>
      <a
        target="_blank"
        [href]="productPageUrl + item.materialNumber"
      >
        <img
          src="assets/images/Icon_link_new.svg"
          [alt]="'mpupInventory.visitProductDetails' | mbTranslate"
        />
        {{'mpupInventory.visitProductDetails' | mbTranslate}}
      </a>
    </div>
  </div>
</div>
